// extracted by mini-css-extract-plugin
export default {"toggleBtn":"ToggleView_toggleBtn__ApN4Z","fadeOut":"ToggleView_fadeOut__sc03d"};